import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SignProcessWizardService } from '../../sign-process-wizard.service';

@Component({
  selector: 'ss-document-upload-step',
  templateUrl: './document-upload-step.component.html',
  styleUrls: ['./document-upload-step.component.css'],
  host: {
    class: 'process-step-outlet display-block full-stretch'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentUploadStepComponent implements OnInit {

  get otherElements() {
    return this._signProcessWizardService.otherElements
  }

  get baseElement() {
    return this._signProcessWizardService.baseElement;
  }

  constructor(
    private readonly _signProcessWizardService: SignProcessWizardService
  ) {

  }

  ngOnInit(): void {
  }

}
